// src/data/eventTypes.js
// Data for event-type landing pages (e.g. birthday party decorators belfast)
// Each entry maps to a unique URL and SEO-targeted page.

export const eventTypes = [
  {
    slug: "birthday-party-decorators-belfast",
    eventLabel: "Birthday Party",
    location: "Belfast",
    locationSlug: "belfast",
    metaTitle: "Birthday Party Decorators Belfast | Balloons, Backdrops & Themed Décor",
    metaDescription:
      "Birthday party decorators in Belfast. Custom balloon garlands, shimmer walls, personalised foil numbers, neon signs and themed backdrops. Delivery, setup & takedown included. WhatsApp for a fast quote.",
    h1: "Birthday Party Decorators Belfast",
    intro:
      "From surprise 18ths to milestone 50th celebrations, we style birthday parties across Belfast with custom balloon garlands, shimmer walls, neon signs and personalised boards. Delivery, setup and takedown all included.",
    whatWeInclude: [
      "Custom colour-matched balloon garlands",
      "Shimmer walls, sequin backdrops & neon signs",
      "'18', '21', '30', '40', '50' personalised foil numbers",
      "Personalised acrylic, foam or mirror welcome boards",
      "Cake plinths, table centrepieces & props",
      "Delivery, professional setup & takedown",
    ],
    relatedTowns: ["newtownabbey", "lisburn", "holywood", "carrickfergus", "bangor"],
    relatedPackages: ["classic-celebration", "luxury-look"],
    faqs: [
      {
        q: "What birthday party decorations are most popular in Belfast?",
        a: "Balloon garlands, shimmer walls, neon signs, and personalised foil numbers are our most booked birthday items. Milestone birthdays (18th, 21st, 30th, 40th, 50th) often include a full backdrop, personalised signage and a cake plinth.",
      },
      {
        q: "Can you style themed birthday parties in Belfast?",
        a: "Yes — we work to any colour palette or theme. Share your inspiration and we'll design around it.",
      },
      {
        q: "Do you do surprise birthday room setups in Belfast?",
        a: "Yes, our Surprise Room Décor service is popular for hotel rooms and home surprises. Ceiling balloons, foil bunting, personalised foil numbers and personalised boards all available.",
      },
      {
        q: "How much does birthday party decor cost in Belfast?",
        a: "Surprise Room Décor and backdrop packages start from £250. Full venue styling is quoted on request.",
      },
      {
        q: "How far in advance should I book for a birthday in Belfast?",
        a: "2–4 weeks is ideal. Peak weekends (summer and December) book up earlier.",
      },
      {
        q: "Do you include setup and takedown for birthday parties?",
        a: "Yes — all birthday packages include delivery, professional setup and takedown.",
      },
    ],
  },
  {
    slug: "baby-shower-decorators-belfast",
    eventLabel: "Baby Shower",
    location: "Belfast",
    locationSlug: "belfast",
    metaTitle: "Baby Shower Decorators Belfast | Balloon Garlands, Backdrops & Welcome Boards",
    metaDescription:
      "Baby shower decorators in Belfast. Soft palettes, themed balloon garlands, personalised welcome boards and styled backdrops. Delivery, setup & takedown included. WhatsApp for a fast quote.",
    h1: "Baby Shower Decorators Belfast",
    intro:
      "We create beautiful baby shower setups across Belfast — soft pastel garlands, personalised welcome boards, themed backdrops and styled table centrepieces. Tell us your theme and we'll handle the rest.",
    whatWeInclude: [
      "Soft palette balloon garlands (pastel, sage, blush, ivory)",
      "Themed shimmer wall or sequin backdrop",
      "Personalised 'Baby Shower' or name welcome boards",
      "Table plinths, props & floral accents",
      "Cake table styling",
      "Delivery, professional setup & takedown",
    ],
    relatedTowns: ["newtownabbey", "lisburn", "holywood", "carrickfergus", "bangor"],
    relatedPackages: ["classic-celebration", "luxury-look"],
    faqs: [
      {
        q: "What baby shower decorations are popular in Belfast?",
        a: "Balloon garlands in soft pastels, personalised welcome boards (acrylic or foam), themed backdrops and table styling are all popular choices.",
      },
      {
        q: "Can you do gender-neutral baby shower decor in Belfast?",
        a: "Yes — sage, ivory, nude and white palettes are ideal for gender-neutral setups. We also do pink, blue, yellow and mint themes.",
      },
      {
        q: "Do you cater for surprise baby showers in Belfast?",
        a: "Yes — we can arrive and set up while the mum-to-be is elsewhere. Just give us access details and timings.",
      },
      {
        q: "How much does baby shower decor cost in Belfast?",
        a: "Packages start from £250. Full room styling from £380. WhatsApp for a personalised quote.",
      },
      {
        q: "How early should I book baby shower decorations in Belfast?",
        a: "3–4 weeks ahead is ideal, especially for popular spring and summer dates.",
      },
      {
        q: "Do you supply personalised boards for baby showers?",
        a: "Yes — acrylic, foam and mirror welcome boards are available as part of packages or as add-ons.",
      },
    ],
  },
  {
    slug: "baby-shower-decorators-northern-ireland",
    eventLabel: "Baby Shower",
    location: "Northern Ireland",
    locationSlug: null,
    metaTitle: "Baby Shower Decorators Northern Ireland | Balloon Garlands & Themed Décor",
    metaDescription:
      "Baby shower decorators across Northern Ireland. Soft palettes, balloon garlands, personalised welcome boards and themed backdrops. Delivery, setup & takedown across Belfast, Lisburn, Bangor and beyond.",
    h1: "Baby Shower Decorators Northern Ireland",
    intro:
      "We travel across Northern Ireland to create stunning baby shower setups — soft balloon garlands, personalised welcome boards, shimmer walls and themed backdrops. Covering Belfast, Lisburn, Bangor, Newtownabbey and 17+ towns.",
    whatWeInclude: [
      "Soft palette balloon garlands tailored to your theme",
      "Shimmer wall, sequin or fabric backdrops",
      "Personalised welcome boards (acrylic, foam or mirror)",
      "Table styling, plinths & floral accents",
      "Cake table centrepiece",
      "Delivery, professional setup & takedown",
    ],
    relatedTowns: ["belfast", "lisburn", "bangor", "newtownabbey", "newtownards"],
    relatedPackages: ["classic-celebration", "luxury-look"],
    faqs: [
      {
        q: "Do you cover all of Northern Ireland for baby showers?",
        a: "Yes — we cover Greater Belfast and 17+ surrounding towns including Lisburn, Bangor, Newtownabbey, Newtownards, Antrim and Carrickfergus.",
      },
      {
        q: "What baby shower styles are popular in Northern Ireland?",
        a: "Pastel balloon garlands, floral-accented backdrops, personalised welcome signs and table styling are consistently popular across NI.",
      },
      {
        q: "Can you match my baby shower colour theme?",
        a: "Yes — share your palette or inspiration and we'll design to match. Popular NI baby shower palettes include sage, blush, ivory, mint and classic pink or blue.",
      },
      {
        q: "How much does baby shower decor cost across Northern Ireland?",
        a: "Backdrop packages start from £250. WhatsApp for a location-specific quote.",
      },
      {
        q: "Are there travel fees for baby shower decor outside Belfast?",
        a: "Local travel within Greater Belfast is included. A small fee may apply for farther towns — we'll confirm when you enquire.",
      },
      {
        q: "How far in advance should I book a baby shower decorator?",
        a: "3–4 weeks ahead is best. Popular weekend slots fill quickly, especially from March to September.",
      },
    ],
  },
  {
    slug: "christening-party-decorators-belfast",
    eventLabel: "Christening",
    location: "Belfast",
    locationSlug: "belfast",
    metaTitle: "Christening Party Decorators Belfast | Elegant Balloon Décor & Backdrops",
    metaDescription:
      "Christening party decorators in Belfast. Elegant balloon garlands, personalised welcome boards, themed backdrops and venue styling. Delivery, setup & takedown included. WhatsApp for a fast quote.",
    h1: "Christening Party Decorators Belfast",
    intro:
      "We create elegant, timeless christening setups across Belfast — soft balloon garlands, personalised welcome boards, backdrop styling and table centrepieces. Discreet, professional and designed to complement your venue.",
    whatWeInclude: [
      "Soft balloon garlands in white, ivory, gold or pastel tones",
      "Themed backdrop or shimmer wall",
      "Personalised 'Christening Day' welcome boards",
      "Table styling, plinths & floral accents",
      "Venue-friendly, non-marking methods",
      "Delivery, professional setup & takedown",
    ],
    relatedTowns: ["newtownabbey", "lisburn", "holywood", "carrickfergus", "bangor"],
    relatedPackages: ["classic-celebration", "luxury-look"],
    faqs: [
      {
        q: "What christening decorations are popular in Belfast?",
        a: "Soft balloon garlands in white, ivory, gold or pastel tones are most popular. Personalised welcome boards, themed backdrops and table plinths are common additions.",
      },
      {
        q: "Can you style christenings at hotels and restaurants in Belfast?",
        a: "Yes — we work with venues throughout Belfast, coordinate access with the venue and use non-marking fixings.",
      },
      {
        q: "Do you do religious or faith-themed christening decor?",
        a: "We can incorporate crosses, dove motifs or other elements into signage and design if requested.",
      },
      {
        q: "How much does christening decor cost in Belfast?",
        a: "Backdrop packages start from £250. Full venue styling from £380. WhatsApp us with your venue and theme for an accurate quote.",
      },
      {
        q: "How early should I book christening decorations in Belfast?",
        a: "4–6 weeks is ideal, especially if you need a specific Sunday slot.",
      },
      {
        q: "Do you include setup and takedown for christening parties?",
        a: "Yes — delivery, professional setup and takedown are included in all packages.",
      },
    ],
  },
  {
    slug: "hen-party-decorators-northern-ireland",
    eventLabel: "Hen Party",
    location: "Northern Ireland",
    locationSlug: null,
    metaTitle: "Hen Party Decorators Northern Ireland | Neon Signs, Shimmer Walls & Balloon Décor",
    metaDescription:
      "Hen party decorators across Northern Ireland. Themed balloon garlands, neon signs, shimmer walls and personalised backdrops. Delivery, setup & takedown across Belfast, Lisburn, Bangor and more.",
    h1: "Hen Party Decorators Northern Ireland",
    intro:
      "We style stunning hen party setups across Northern Ireland — themed neon signs, sequin walls, personalised backdrops, balloon garlands and welcome boards. Available for hotel rooms, venues and private home parties.",
    whatWeInclude: [
      "Neon signs (custom name or 'Bride to Be' style)",
      "Sequin shimmer walls & themed backdrops",
      "Balloon garlands in bride-approved colours",
      "Personalised welcome boards & props",
      "Surprise room setups (hotel rooms & home)",
      "Delivery, professional setup & takedown",
    ],
    relatedTowns: ["belfast", "lisburn", "bangor", "newtownabbey", "newtownards"],
    relatedPackages: ["classic-celebration", "luxury-look"],
    faqs: [
      {
        q: "What hen party decorations are popular in Northern Ireland?",
        a: "Neon signs, sequin shimmer walls, balloon garlands, personalised welcome boards and room décor packages are our most popular hen party choices.",
      },
      {
        q: "Can you style a hotel room for a hen party?",
        a: "Yes — our Surprise Room Décor service is perfect for hen party hotel rooms. Ceiling balloons, foil bunting, neon signs and custom boards all available.",
      },
      {
        q: "Do you offer themed hen party decor?",
        a: "Yes — we design around the bride's favourite colours, a theme (disco, glam, tropical, bridal) or a specific colour palette.",
      },
      {
        q: "How much does hen party decor cost in Northern Ireland?",
        a: "Room packages start from £250. Venue setups from £380. Neon sign hire from £50. WhatsApp for a quick quote.",
      },
      {
        q: "How far in advance should I book hen party decorations?",
        a: "2–3 weeks ahead is fine for most setups; Friday and Saturday nights book quickly so earlier is better.",
      },
      {
        q: "Do you cover the whole of Northern Ireland for hen parties?",
        a: "Yes — we cover Belfast, Lisburn, Bangor, Newtownabbey, Antrim, Carrickfergus and 17+ towns across NI.",
      },
    ],
  },
  {
    slug: "gender-reveal-decorators-belfast",
    eventLabel: "Gender Reveal",
    location: "Belfast",
    locationSlug: "belfast",
    metaTitle: "Gender Reveal Decorators Belfast | Balloon Décor, Backdrops & Themed Setups",
    metaDescription:
      "Gender reveal decorators in Belfast. Balloon garlands, themed backdrops, welcome boards and styled setups for your gender reveal party. Delivery, setup & takedown included. WhatsApp for a fast quote.",
    h1: "Gender Reveal Decorators Belfast",
    intro:
      "Make your gender reveal unforgettable with a styled balloon garland, themed backdrop and personalised welcome board. We cover Belfast and surrounding areas — delivery, setup and takedown all included.",
    whatWeInclude: [
      "Neutral balloon garlands (white, ivory, gold, lemon)",
      "Themed backdrops & shimmer walls",
      "'He or She?' personalised welcome boards",
      "Pink & blue accent balloon styling",
      "Table centrepieces & cake table props",
      "Delivery, professional setup & takedown",
    ],
    relatedTowns: ["newtownabbey", "lisburn", "holywood", "carrickfergus", "bangor"],
    relatedPackages: ["classic-celebration"],
    faqs: [
      {
        q: "What gender reveal decorations are popular in Belfast?",
        a: "Balloon garlands in neutral tones, themed backdrops with 'He or She?' signage, and welcome boards are popular. Pink or blue accents are added to the main garland to hint at the reveal.",
      },
      {
        q: "Can you do a fully neutral gender reveal setup?",
        a: "Yes — white, gold, ivory and lemon palettes are popular for reveal setups before the big moment.",
      },
      {
        q: "Do you supply gender reveal balloon pops or boxes?",
        a: "We specialise in backdrop styling and garlands. We can incorporate reveal-specific colour accents into our designs on request.",
      },
      {
        q: "How much does gender reveal decor cost in Belfast?",
        a: "Styled packages start from £250. WhatsApp for a personalised quote.",
      },
      {
        q: "How early should I book gender reveal decorations?",
        a: "2–3 weeks ahead is ideal.",
      },
      {
        q: "Do you include setup and takedown for gender reveal parties?",
        a: "Yes — all packages include delivery, professional setup and takedown.",
      },
    ],
  },
  {
    slug: "18th-birthday-party-decorators-belfast",
    eventLabel: "18th Birthday Party",
    location: "Belfast",
    locationSlug: "belfast",
    metaTitle: "18th Birthday Party Decorators Belfast | Balloon Garlands, Neon Signs & Shimmer Walls",
    metaDescription:
      "18th birthday party decorators in Belfast. Custom balloon garlands, neon signs, shimmer walls, '18' personalised foil numbers and personalised backdrops. Setup & takedown included. WhatsApp for a fast quote.",
    h1: "18th Birthday Party Decorators Belfast",
    intro:
      "Turn 18 in style with a stunning balloon garland, shimmer wall, personalised neon sign and '18' foil numbers. We style 18th birthday parties across Belfast — from intimate home setups to full venue installations.",
    whatWeInclude: [
      "'18' personalised foil numbers",
      "Balloon garland in custom colours",
      "Shimmer wall or sequin backdrop",
      "Personalised neon sign or acrylic welcome board",
      "Cake plinth & table props",
      "Delivery, professional setup & takedown",
    ],
    relatedTowns: ["newtownabbey", "lisburn", "holywood", "carrickfergus", "bangor"],
    relatedPackages: ["classic-celebration", "luxury-look"],
    faqs: [
      {
        q: "What decorations are most popular for 18th birthdays in Belfast?",
        a: "Neon signs, shimmer walls, balloon garlands, '18' personalised foil numbers and personalised backdrops are our most popular 18th birthday choices.",
      },
      {
        q: "Can you include a personalised neon sign for an 18th?",
        a: "Yes — neon signs are available as part of Classic Celebration and Luxury Look packages, or as a standalone add-on.",
      },
      {
        q: "Do you do 18th birthday room surprises in Belfast?",
        a: "Yes — our Surprise Room Décor service is popular for 18th birthday reveals at home or in a hotel.",
      },
      {
        q: "How much does 18th birthday decor cost in Belfast?",
        a: "Backdrop packages start from £250. Full venue styling from £380. WhatsApp for a quote.",
      },
      {
        q: "Do you supply '18' personalised foil numbers?",
        a: "Personalised foil numbers can be included with Surprise Room Décor or a suitable backdrop package. Share the age and colour theme when requesting a quote.",
      },
      {
        q: "How far in advance should I book for an 18th birthday in Belfast?",
        a: "2–4 weeks is ideal. Saturday evening slots in particular fill up quickly.",
      },
    ],
  },
  {
    slug: "21st-birthday-party-decorators-belfast",
    eventLabel: "21st Birthday Party",
    location: "Belfast",
    locationSlug: "belfast",
    metaTitle: "21st Birthday Party Decorators Belfast | Balloon Garlands, Neon Signs & Backdrops",
    metaDescription:
      "21st birthday party decorators in Belfast. Custom balloon garlands, neon signs, shimmer walls, '21' personalised foil numbers and themed backdrops. Setup & takedown included. WhatsApp for a fast quote.",
    h1: "21st Birthday Party Decorators Belfast",
    intro:
      "Celebrate in style with a custom balloon garland, shimmer wall, neon sign and personalised '21' foil numbers. We style 21st birthday parties across Belfast — delivering, setting up and tidying away so you can focus on the celebration.",
    whatWeInclude: [
      "'21' personalised foil numbers",
      "Balloon garland in custom colours",
      "Shimmer wall, sequin or frame backdrop",
      "Personalised neon sign or acrylic welcome board",
      "Cake plinth & marquee number",
      "Delivery, professional setup & takedown",
    ],
    relatedTowns: ["newtownabbey", "lisburn", "holywood", "carrickfergus", "bangor"],
    relatedPackages: ["classic-celebration", "luxury-look"],
    faqs: [
      {
        q: "What decorations are most popular for 21st birthdays in Belfast?",
        a: "Balloon garlands, shimmer walls, neon signs, '21' personalised foil numbers and personalised welcome boards are our top 21st birthday choices.",
      },
      {
        q: "Can you include a '21' personalised foil numbers?",
        a: "Personalised foil numbers can be included with Surprise Room Décor or a suitable backdrop package. Share the age and colour theme when requesting a quote.",
      },
      {
        q: "What packages work best for a 21st birthday?",
        a: "Our Classic Celebration (from £250) is perfect for a 21st — includes a balloon garland, neon sign, cake plinth and marquee number. Luxury Look (from £380) adds a sequin wall and premium garland.",
      },
      {
        q: "How much does 21st birthday decor cost in Belfast?",
        a: "Backdrop packages start from £250. Luxury setups from £380. WhatsApp for a personalised quote.",
      },
      {
        q: "Can you style a 21st at a Belfast venue or hotel?",
        a: "Yes — we work with hotels, restaurants and function rooms across Belfast, coordinating access and timings with your venue.",
      },
      {
        q: "How far in advance should I book for a 21st birthday in Belfast?",
        a: "2–4 weeks is ideal. Peak weekend evenings can book up fast.",
      },
    ],
  },
  {
    slug: "corporate-event-decorators-belfast",
    eventLabel: "Corporate Event",
    location: "Belfast",
    locationSlug: "belfast",
    metaTitle: "Corporate Event Decorators Belfast | Branded Balloons, Balloon Arches & Office Party Décor",
    metaDescription:
      "Corporate event decorators in Belfast. Branded balloon arches, shimmer walls, welcome boards and office party styling for product launches, office openings, award nights and team celebrations. Delivery, setup & takedown included.",
    h1: "Corporate Event Decorators Belfast",
    intro:
      "From office openings and product launches to award ceremonies and Christmas parties, we style corporate events across Belfast with branded balloon arches, shimmer walls, neon signs and personalised signage. Professional, punctual and fully managed — delivery, setup and takedown all included.",
    whatWeInclude: [
      "Branded balloon arches & garlands (company colours)",
      "Shimmer walls & sequin backdrops for photo moments",
      "Personalised welcome boards & branded signage",
      "Coordinated balloon displays & centrepieces for venues",
      "Neon signs (company name, slogan or event title)",
      "Delivery, professional setup & takedown",
    ],
    relatedTowns: ["belfast", "lisburn", "newtownabbey", "holywood", "carrickfergus"],
    relatedPackages: ["classic-celebration", "luxury-look"],
    faqs: [
      {
        q: "What corporate event decorations are available in Belfast?",
        a: "We offer branded balloon arches, shimmer walls, neon signs, personalised welcome boards, Surprise Room Décor and full venue styling. All designs can be matched to your brand colours or event theme.",
      },
      {
        q: "Can you match our company brand colours?",
        a: "Yes — share your brand palette and we'll colour-match balloon garlands, arches and signage to your brand guidelines.",
      },
      {
        q: "Do you decorate office openings and product launches in Belfast?",
        a: "Yes — office openings, product launches, award evenings and team celebrations are all events we regularly style. We can also provide decorations that last across multi-day events.",
      },
      {
        q: "How much does corporate event decor cost in Belfast?",
        a: "Corporate setups typically start from £250 for a balloon arch with signage. Full venue installations are quoted based on scope. WhatsApp for a tailored quote.",
      },
      {
        q: "Can your decorations last across multiple days?",
        a: "Yes — our balloon setups are built to last. We've provided decorations for week-long office events that held up throughout without any issues.",
      },
      {
        q: "How far in advance should I book corporate event decorations?",
        a: "2–4 weeks is ideal for standard setups. For large installations or events with specific brand requirements, booking earlier gives more lead time for design.",
      },
      {
        q: "Do you offer Christmas party decorations for offices in Belfast?",
        a: "Yes — festive office party styling is one of our busiest seasons. Seasonal balloon garlands, backdrops and themed signage are all available. Book early as December fills quickly.",
      },
    ],
  },
];

export const eventTypesBySlug = Object.fromEntries(
  eventTypes.map((e) => [e.slug, e])
);
